import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getCarValueRangeDropdown } from '../../actions/carValueRangeDropdown';
import { updateCarValueAndExcess } from '../../actions/updateCarValueAndExcess';
import PropTypes from 'prop-types';
import { Field, reduxForm, initialize } from 'redux-form';
import { injectIntl, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import SidePanel from './SidePanel';
import FooterButton from './FooterButton';
import s from './ListPlaceStep1.css';
import cs from '../commonStyle.css';
import messages from '../../locale/messages';
import showToaster from '../../helpers/toasterMessages/showToaster';
import { manageListingSteps } from '../../actions/manageListingSteps';
import CommonFormComponent from '../CommonField/CommonFormComponent';
import CurrencyConverter from '../CurrencyConverter/CurrencyConverter';

class CarValueExcess extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    previousPage: PropTypes.any,
    nextPage: PropTypes.any,
    formPage: PropTypes.string,
    step: PropTypes.any,
    intl: PropTypes.object,
    manageListingSteps: PropTypes.func,
    completedSteps: PropTypes.array,
    initialValues: PropTypes.object,
    carValueRangeOptions: PropTypes.array,
    loading: PropTypes.bool,
    dispatch: PropTypes.func,
    listId: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedValue: props.initialValues?.carValue || '',
      isSubmitting: false
    };
  }

  componentDidMount() {
    const { listId, getCarValueRangeDropdown } = this.props;
    if (listId) {
      getCarValueRangeDropdown(listId);
    }
  }

  componentDidUpdate(prevProps) {
    const { carValueRangeOptions } = this.props;
    
    // Always update selected value when options are loaded or change
    if (carValueRangeOptions?.length > 0 && (
        carValueRangeOptions !== prevProps.carValueRangeOptions || 
        this.props.initialValues?.carValue !== prevProps.initialValues?.carValue
      )) {
      const selectedOption = carValueRangeOptions.find(option => option.selected);
      if (selectedOption) {
        const newSelectedValue = String(selectedOption.id);
        if (this.state.selectedValue !== newSelectedValue) {
          this.setState({ selectedValue: newSelectedValue });
        }
      }
    }
  }

  handleSelectChange = (e) => {
    this.setState({ selectedValue: e.target.value });
  };

  onSubmit = async (values) => {
    const { listId, nextPage, manageListingSteps } = this.props;
    const { selectedValue } = this.state;

    if (!selectedValue) {
      showToaster({
        messageId: "Please select a car value range",
        toasterType: "error",
      });
      return;
    }

    this.setState({ isSubmitting: true });

    try {
      const result = await updateCarValueAndExcess(listId, Number(selectedValue));
      if (result?.status === 200) {
        await manageListingSteps(listId.toString(), 5);
        nextPage("home");
      }
    } catch (error) {
      console.error('Error updating car value:', error);
      showToaster({
        messageId: "Failed to update car value and excess. Please try again.",
        toasterType: "error",
      });
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  render() {
    const { 
      handleSubmit, 
      previousPage, 
      formPage, 
      step, 
      intl, 
      carValueRangeOptions = [], 
      loading ,
      base,
      toCurrency
    } = this.props;

    const { selectedValue, isSubmitting } = this.state;
    const isFormSubmitting = loading || isSubmitting;

    return (
      <div className={cx(s.stepGrid, 'stepGridRTL')}>
        <SidePanel
          title={intl.formatMessage(messages.step5HeadingCar)}
          landingContent={intl.formatMessage(messages.setCarValueExcess)}
        />
        <div>
          <form onSubmit={handleSubmit(this.onSubmit)}>
            <div className={s.landingMainContent}>
              <div className={s.flexCenter}>
                <div className={cx(s.contentLeft, "contentLeftStepRTL")}> 
                  <h3 className={cx(cs.spaceBottom3, cs.commonTitleText, cs.fontWeightExtraBold, cs.fontDMSans)}>
                    <FormattedMessage {...messages.step5SubHeadingCar} />
                  </h3>
                  <p className={cx(cs.commonContentText, cs.fontDMSans)}>
                    <FormattedMessage {...messages.step5HeadingContentCar} />
                  </p>
                  <FormGroup className={cx(s.formGroup, cs.spaceTop7)}>
                <ControlLabel className={s.landingLabel}>
                  <FormattedMessage {...messages.selectCarValue} />
                </ControlLabel>
                    <select
                      name="carValue"
                      className={cx(s.formControlSelect, s.jumboSelect, s.marginBottompageTwo, "form-control")}
                      disabled={isFormSubmitting}
                      value={selectedValue}
                      onChange={this.handleSelectChange}
                    >
                      <option value="">{intl.formatMessage(messages.selectCarLabel)}</option>
                      {carValueRangeOptions.map(option => (
                        <option key={option.id} value={String(option.id)}>
                          {option.car_value_range}
                        </option>
                      ))}
                    </select>
                  </FormGroup>

                  
     

{carValueRangeOptions && carValueRangeOptions.length > 0 && (() => {
  const selectedOption = carValueRangeOptions.find(item => String(item.id) === String(selectedValue));
  return selectedOption ? (
    <ControlLabel className={s.landingLabel}>
      <FormattedMessage {...messages.selectExcessValue} />: {' '}
      <CurrencyConverter
        amount={selectedOption.recommended_excess}
        from={base}
        toCurrency={toCurrency}
      />
    </ControlLabel>
  ) : null;
})()}
                </div>
              </div>
            </div>

            {/* Display insurancePrice if provided */}
            {typeof this.props.insurancePrice !== 'undefined' && this.props.insurancePrice !== null && Number(this.props.insurancePrice) > 0 && (
              <div style={{ marginTop: 20 }}>
                <label style={{ fontWeight: 'bold' }}>
                  <FormattedMessage {...messages.insurancePriceLabel || { id: 'insurancePriceLabel', defaultMessage: 'Insurance Price' }} />:
                </label>
                <span style={{ marginLeft: 8 }}>
                  <CurrencyConverter
                    amount={Number(this.props.insurancePrice)}
                    from={this.props.base}
                    toCurrency={this.props.toCurrency}
                  />
                </span>
              </div>
            )}
            <FooterButton
              isDisabled={isFormSubmitting}
              nextPage={null}
              previousPage={previousPage}
              nextPagePath={"next-step"}
              previousPagePath={"verification-document"}
              formPage={formPage}
              step={step}
              type="submit"
              onClick={handleSubmit(this.onSubmit)}
              loading={isFormSubmitting}
            />
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const carValueRangeOptions = state.carValueRangeDropdown.carValueRangeOptions || [];
  const selectedOption = carValueRangeOptions.find(option => option.selected) || {};
  return {
    carValueRangeOptions,
    loading: state.carValueRangeDropdown.loading,
    base: state.currency.base,
    toCurrency: state.currency.to,
    rates: state.currency.rates,
    initialValues: {
      carValue: selectedOption.id ? String(selectedOption.id) : ''
    }
  };
};

const mapDispatchToProps = {
  getCarValueRangeDropdown,
  manageListingSteps,
};

CarValueExcess = connect(mapStateToProps, mapDispatchToProps)(CarValueExcess);

CarValueExcess = reduxForm({
  form: 'ListPlaceStep1',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  enableReinitialize: true,
})(CarValueExcess);

export default injectIntl(withStyles(s, cs)(CarValueExcess));
